import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddQuestionInitialValues } from "@src/pages/question/question-table-component/QuestionTypes";

interface ChapterData {
  id: string;
  parentType: string;
  name: string;
}

interface AddQuestionDraftState {
  isOpen: boolean;
  draftValues: AddQuestionInitialValues | null;
  selectedChapter: ChapterData | null;
  keepDataForNextQuestion: boolean;
  isEditMode?: boolean;
  isVerifierMode?: boolean;
  questionId?: string | null;
  existingQuestion?: any;
}

const initialState: AddQuestionDraftState = {
  isOpen: false,
  draftValues: null,
  selectedChapter: null,
  keepDataForNextQuestion: false,
  isEditMode: false,
  isVerifierMode: false,
  questionId: null,
  existingQuestion: null,
};

const addQuestionDraftSlice = createSlice({
  name: "addQuestionDraft",
  initialState,
  reducers: {
    setDraft(
      state,
      action: PayloadAction<{
        draftValues: AddQuestionInitialValues;
        selectedChapter: ChapterData | null;
        keepDataForNextQuestion: boolean;
        isEditMode?: boolean;
        isVerifierMode?: boolean;
        questionId?: string | null;
        existingQuestion?: any;
      }>
    ) {
      state.draftValues = action.payload.draftValues;
      state.selectedChapter = action.payload.selectedChapter;
      state.keepDataForNextQuestion = action.payload.keepDataForNextQuestion;
      state.isEditMode = action.payload.isEditMode ?? false;
      state.isVerifierMode = action.payload.isVerifierMode ?? false;
      state.questionId = action.payload.questionId ?? null;
      state.existingQuestion = action.payload.existingQuestion ?? null;
    },
    setIsOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    clearDraft(state) {
      state.draftValues = null;
      state.selectedChapter = null;
      state.isOpen = false;
      state.isEditMode = false;
      state.isVerifierMode = false;
      state.questionId = null;
      state.existingQuestion = null;
    },
  },
});

export const { setDraft, setIsOpen, clearDraft } = addQuestionDraftSlice.actions;
export default addQuestionDraftSlice.reducer;
